import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { FaUser, FaArrowRight } from "react-icons/fa";
import backgroundIllustration from "../assets/couple.png";
import "../css/Login.css";
import { useTranslation } from "react-i18next";

function ForgetPassword() {
  const { t } = useTranslation();
  const [username, setUsername] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/forgot-password`, { username });
      setMessage("forgotPassword.success");
    } catch (error) {
      setMessage("forgotPassword.error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="conteneur-connexion">
      <div className="carte-connexion">
        {/* Left Side */}
        <div className="cote-gauche">
          <img src={backgroundIllustration} alt={t("login.coupleAlt")} className="image-connexion" />
          <div className="overlay-connexion">
            <h2>{t("login.heroTitle")}</h2>
            <p>{t("login.heroSubtitle")}</p>
          </div>
        </div>

        {/* Right Side */}
        <div className="cote-droit">
          <div className="en-tete-connexion">
            <img src={require("../assets/logo.png")} alt="Logo MyHalal" className="logo-connexion" />
            <h2>{t("login.forgotPassword")}</h2>
            <p>{t("forgotPassword.instructions")}</p>
          </div>

          <form onSubmit={handleSubmit} className="formulaire-connexion">
            {message && <div className="erreur-connexion" role="status">{t(message)}</div>}

            <div className="groupe-input">
              <FaUser className="icone-input" />
              <input
                type="email"
                placeholder={t("forgotPassword.email")}
                aria-label={t("forgotPassword.email")}
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </div>

            <button type="submit" className="bouton-connexion" disabled={loading}>
              {t(loading ? "forgotPassword.sending" : "forgotPassword.sendLink")} <FaArrowRight />
            </button>

            <p className="lien-inscription">
              <Link to="/login">← {t("forgotPassword.backToLogin")}</Link>
            </p>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ForgetPassword;
